const variant_inputs = document.querySelectorAll("input.variant-option-input");
const table_rows = document.querySelectorAll("[data-filterable]");

const OPTION1_VAR_INPUT_CONTAINER_ID = "fieldset-0";
const OPTION2_VAR_INPUT_CONTAINER_ID = "fieldset-1";

const applyFilter = () => {
  const availableOption1Vals = findAvailableVariantValues(
    OPTION1_VAR_INPUT_CONTAINER_ID
  );
  const availableOption2Vals = findAvailableVariantValues(
    OPTION2_VAR_INPUT_CONTAINER_ID
  );

  const el_filtered = [...table_rows].filter((el) => {
    const props = el.getAttribute("data-filterable").trim().split('*');
    const row_option1 = props[0];
    const row_option2 = props[1];
    // if(row_option1){
    //   const isRowAvailable =
    //   availableOption1Vals.includes(row_option1);
    //   console.log([row_option1], isRowAvailable);
    //   return isRowAvailable; 
    // }

    const isRowAvailable =
      availableOption1Vals.includes(row_option1) &&
      availableOption2Vals.includes(row_option2);
    return isRowAvailable; 
  });
  showTableRows(el_filtered);
}; 

function findAvailableVariantValues(parentId) {
  const el_parent = document.getElementById(parentId);
  const variantOpInputs = el_parent.querySelectorAll(
    "input.variant-option-input"
  );

  const checkedVariantValues = [...variantOpInputs]
    .filter((el) => el.checked && el.value)
    .map((el) => el.value);

  if (checkedVariantValues.length > 0) {
    return checkedVariantValues;
  }

  const notDisabledLabels = el_parent.querySelectorAll(
    "label.variant-value:not(.not-available)"
  );
  return [...notDisabledLabels].map((label) =>
    label.getAttribute("data-prod-value")
  );
}

function showTableRows(showRows) {
  // Hide all rows
  table_rows.forEach((el) => {
    el.classList.add("is-hidden"),
      Array.from(el.getElementsByTagName("input")).forEach((input) => {
        input.disabled = true;
      });
  });

  // Show only the selected rows
  showRows.forEach((el) => {
    el.classList.remove("is-hidden"),
      Array.from(el.getElementsByTagName("input")).forEach((input) => {
        input.disabled = false;
      });
  });
}

// Assign event listener
variant_inputs.forEach((el) => el.addEventListener("change", applyFilter));
// Init
applyFilter();

